
import {
    OPEN_ETHERPAD_FINAL,
    OPEN_ETHER_PAD,
    SET_DOCUMENT_EDITING_STATUS,
    SET_DOCUMENT_URL,
    TOGGLE_DOCUMENT_EDIT,
    TOGGLE_DOCUMENT_EDITING,
    WHICH_PARTICPANT_ETHERPAD
} from './actionTypes';

/**
 * Dispatches an action to set whether document editing has started or stopped.
 *
 * @param {boolean} editing - Whether or not a document is currently being
 * edited.
 * @returns {{
 *    type: SET_DOCUMENT_EDITING_STATUS,
 *    editing: boolean
 * }}
 */
export function setDocumentEditingState(editing: boolean) {
    return {
        type: SET_DOCUMENT_EDITING_STATUS,
        editing
    };
}

/**
 * Dispatches an action to set the shared document URL.
 *
 * @param {string} documentUrl - The shared document URL.
 * @returns {{
 *    type: SET_DOCUMENT_URL,
 *    documentUrl: string
 * }}
 */
export function setDocumentUrl(documentUrl: ?string) {
    return {
        type: SET_DOCUMENT_URL,
        documentUrl
    };
}

/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @returns {{
 *    type: TOGGLE_DOCUMENT_EDITING
 * }}
 */
export function toggleDocument() {
    return {
        type: TOGGLE_DOCUMENT_EDITING
    };
}


/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {boolean} onEdit - Whether or not a document is currently being.
 * @returns {{
 *    type: TOGGLE_DOCUMENT_EDITING,
 *    onEdit: boolean
 * }}
 */
export function toggleDocumentedit(onEdit: boolean) {
    return {
        type: TOGGLE_DOCUMENT_EDIT,
        onEdit
    };
}

/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {string} partId - Whether or not a document is currently being.
 * @returns {{
 *    type: TOGGLE_DOCUMENT_EDITING,
 *    onEdit: boolean
 * }}
 */
export function whichParticipant(partId: ?string) {
    return {
        type: WHICH_PARTICPANT_ETHERPAD,
        partId
    };
}

/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {string} open - Whether or not a document is currently being.
 * @returns {{
*    type: OPEN_ETHER_PAD,
*    open: boolean
* }}
*/
export function openEtherPadFunction(open) {
    return {
        type: OPEN_ETHER_PAD,
        open
    };
}

/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {string} open - Whether or not a document is currently being.
 * @returns {{
*    type: OPEN_ETHERPAD_FINAL,
*    open: boolean
* }}
*/
export function openEtherPadFinal(open) {
    return {
        type: OPEN_ETHERPAD_FINAL,
        open
    };
}
